import { Label as HeadlessUILabel } from "@headlessui/react";

/** Props Interface */
interface LabelProps {
	children: React.ReactNode;
	htmlFor: string | undefined;
}

export const Label: React.FC<LabelProps> = ({ children, htmlFor }) => {
	/** Render */
	return (
		<HeadlessUILabel
			htmlFor={htmlFor}
			className="label"
		>
			{children}
		</HeadlessUILabel>
	);
};
